import { Badge } from '@mantine/core';
import { MessageState } from '#/components/ui/messages/model';

export const MESSAGE_STATE_CONFIG = {
  draft: { key: 'draft', label: '未審核', color: 'pink' },
  approved: { key: 'approved', label: '已審核', color: 'teal' },
  publishing: { key: 'publishing', label: '發送中', color: 'orange' },
  published: { key: 'published', label: '已發送', color: 'blue' },
  revoking: { key: 'revoking', label: '撤回中', color: 'cyan' },
  revoked: { key: 'revoked', label: '已撤回', color: 'dark' },
  deleted: { key: 'deleted', label: '已刪除', color: 'dark.9' },
} as const satisfies Record<
  MessageState,
  { key: MessageState; label: string; color: string }
>;

export const MessageStateBadge = ({ state }: { state: MessageState }) => {
  const { label, color } = MESSAGE_STATE_CONFIG[state];

  return <Badge color={color}>{label}</Badge>;
};
